import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  setInlineBackgroundColor,
  setInlineTextColor
} from 'helpers/LandingPageUtils';
import LandingPageLink from 'components/landing/LandingPageLink';
import LandingPageImage from 'components/landing/LandingPageImage';
import MelodyVideoPlayer from 'components/common/melodyVideo/MelodyVideoPlayer';

import css from 'styles/components/landing/melodyHero.scss';

const MelodyHero = ({ slotName, slotIndex, slotDetails, onLandingComponentClick, shouldLazyLoad }, { testId }) => {
  const {
    heading,
    src,
    mobilesrc,
    retina,
    link,
    alt,
    gae,
    copy,
    subtext,
    cta,
    bgcolor,
    textcolor,
    brandsrc,
    brandretina,
    brandalt,
    videoSrc,
    poster,
    isEmbedded,
    autoplay,
    monetateId,
    loop,
    mobileVideoSrc,
    tabletVideoSrc
  } = slotDetails;

  const makeVideo = () => {
    const slotDetails = { src: videoSrc, poster, isEmbedded, autoplay, loop, mobileVideoSrc, tabletVideoSrc };
    return videoSrc && <MelodyVideoPlayer slotDetails={slotDetails} />;
  };

  const makeBrandImg = () => brandsrc &&
    <LandingPageImage
      src={brandsrc}
      retina={brandretina}
      alt={brandalt}
      shouldLazyLoad={shouldLazyLoad}
      className={css.lazyBrnd}
    />;

  const makeCtaBtn = () => (cta ? <p className={css.cta}>{cta}</p> : null);

  const styling = (textcolor === 'white') ? css.contentWrapCtaWhite : css.contentWrapCtaDefault;
  const contentStyle = setInlineBackgroundColor(bgcolor);

  const linkProps = {
    'className': cn(css.wrap, 'm-hero-nav', styling),
    'style': contentStyle,
    'onClick': onLandingComponentClick,
    'data-eventlabel': 'melodyHero',
    'data-slotindex': slotIndex,
    'data-eventvalue': gae,
    'data-monetate-id': monetateId
  };

  const videoProps = {
    ...linkProps,
    'className': cn(css.contents, styling),
    'data-test-id': testId('melodyHero')
  };

  const getContent = () => {
    const content = (
      <>
        {heading && <h2 style={setInlineTextColor(textcolor)}>{heading}</h2>}
        {makeBrandImg()}
        {copy && <p style={setInlineTextColor(textcolor)} className={css.copy}>{copy}</p>}
        {subtext && <p className={css.subtext}>{subtext}</p>}
        {makeCtaBtn()}
      </>
    );

    return videoSrc && link
      ?
      <LandingPageLink url={link} {...videoProps}>
        {content}
      </LandingPageLink>
      : <div
        className={css.contents}
        style={contentStyle}
        data-test-id={testId('melodyHero')}
        data-slot-id={slotName}
      >
        {content}
      </div>;
  };
  const media = (
    <div className={css.imageContainer}>
      {makeVideo() ||
        <LandingPageImage
          src={src}
          mobilesrc={mobilesrc}
          retina={retina}
          alt={alt}
          shouldLazyLoad={shouldLazyLoad}
          className={css.lazyImg}
        />
      }
    </div>
  );

  const component = (
    <>
      {getContent()}
      {media}
    </>
  );

  return !videoSrc && link
    ?
    <LandingPageLink url={link} {...linkProps}>
      {component}
    </LandingPageLink>
    : <div
      className={cn(
        css.wrap, styling,
        { [css.videoWrap]: videoSrc }
      )}
      data-slot-id={slotName}
      data-monetate-id={monetateId}>
      {component}
    </div>;
};

MelodyHero.contextTypes = {
  testId: PropTypes.func
};

export default MelodyHero;
